import(/* webpackMode: "eager", webpackExports: ["default","error"] */ "/app/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/public/assets/css/recruitment/recruitment.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(layout)/(thong-tin-cong-ty)/tuyen-dung/_components/ClientComp.tsx");
